import { CONTENT_STRATEGY, DomInsertionService, ReplaceableComponentsService } from '@abp/ng.core';
import { inject, provideAppInitializer } from '@angular/core';
import { AccountLayoutComponent } from '../layouts/account/account-layout.component';
import { ApplicationLayoutComponent } from '../layouts/application/application-layout.component';
import { EmptyLayoutComponent } from '../layouts/empty/empty-layout.component';
import { CoachingLayoutComponent } from '../layouts/coaching/coaching-layout.component';
import styles from '../constants/styles';
import { eThemeBasicComponents } from '../models/components';

export const BASIC_THEME_STYLES_PROVIDERS = [
  provideAppInitializer(() => {
    const initializerFn = configureStyles(
      inject(DomInsertionService),
      inject(ReplaceableComponentsService),
    );
    return initializerFn();
  }),
];

export function configureStyles(
  domInsertion: DomInsertionService,
  replaceableComponents: ReplaceableComponentsService,
) {
  return () => {
    domInsertion.insertContent(CONTENT_STRATEGY.AppendStyleToHead(styles));

    initLayouts(replaceableComponents);
  };
}

function initLayouts(replaceableComponents: ReplaceableComponentsService) {
  replaceableComponents.add({
    key: eThemeBasicComponents.ApplicationLayout,
    component: ApplicationLayoutComponent,
  });
  replaceableComponents.add({
    key: eThemeBasicComponents.AccountLayout,
    component: AccountLayoutComponent,
  });
  replaceableComponents.add({
    key: eThemeBasicComponents.EmptyLayout,
    component: EmptyLayoutComponent,
  });
  replaceableComponents.add({
    key: 'coaching' as any,
    component: CoachingLayoutComponent,
  });
}
